import {
  CanAccess,
  CreateBase,
  Form,
  useGetIdentity,
  useTranslate,
} from "ra-core";
import { Navigate } from "react-router";
import { Card, CardContent } from "@/components/ui/card";
import { CancelButton } from "@/components/admin/cancel-button";
import { SaveButton } from "@/components/admin/form";

import type { Client } from "../types";
import { ClientInputs } from "./ClientInputs";
import { cleanupClientForSave } from "./clientValidation";

/**
 * Reachable from the clients list; lands on the client show page on save
 * (`redirect="show"`), per the ticket's acceptance criteria.
 *
 * The whole page is gated by `canAccess` so a role without create access
 * (auditoria, back-office) can't reach it by typing the URL directly
 * (react-admin's <Resource create=.../> route itself is not access-gated).
 */
export const ClientCreate = () => {
  const { identity } = useGetIdentity();
  const translate = useTranslate();
  return (
    <CanAccess
      resource="clients"
      action="create"
      accessDenied={<Navigate to="/clients" replace />}
    >
      <CreateBase
        redirect="show"
        transform={(values: Partial<Client>) => cleanupClientForSave(values)}
      >
        <div className="mt-2 flex lg:mr-72">
          <div className="flex-1">
            <Form defaultValues={{ sales_id: identity?.id }}>
              <Card>
                <CardContent>
                  <ClientInputs />
                  <div
                    role="toolbar"
                    className="sticky flex pt-4 pb-4 md:pb-0 bottom-0 bg-linear-to-b from-transparent to-card to-10% flex-row justify-end gap-2"
                  >
                    <CancelButton />
                    <SaveButton
                      label={translate("resources.clients.action.create", {
                        _: "Create Client",
                      })}
                    />
                  </div>
                </CardContent>
              </Card>
            </Form>
          </div>
        </div>
      </CreateBase>
    </CanAccess>
  );
};
